import Vue from "vue";
import { translation } from '@/plugins/i18n';
// import { transferMoney } from 'common/utils';
import trackings from '@/aspects/trackings';
import query from 'query-string';
import _ from "lodash";
import { priceByMonth, transferMoney } from '@/utils/money';
import { getCurrency } from '@/utils/currency';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import Loading from '@zoom/zoom-ui/src/components/loading';
import globalEventBus from '@/common/global-event-bus';
import { isMobile, isTablet, isDesktop, isMobileInClient, isTabletInClient, isDesktopInClient } from '@/utils/responsive';
import { SHARE_TYPE_ENUM } from '@/views/config/shopping-cart/share-link.vue';
import { routePathMap } from '@/router/constant';
import { BASE_PLAN_SUB_TYPES, PageTypes } from '@/common/constants.js'
import { $cookie } from '@/common/utils'
import AltIosNativeSelect from "@/components/alt-ios-native-select";
import { isEmptyVal } from '@/utils/index';
import { modalHybrid } from '@/utils/modal-utils.js';
import { modalPopLink, interceptLink } from './directives';

Vue.component("alt-ios-native-select", AltIosNativeSelect);

Vue.directive("modal-pop-link", modalPopLink);
Vue.directive("intercept-link", interceptLink);

const isBasic2ProInClient = () => {
  return modalHybrid.isInWebview &&
    pageConfig.pageType === PageTypes.modal &&
    pageConfig.type === flowTypes.basic2pro
}

let loader;

export const $query = query.parse(location.search);

export const $tracking = trackings;

export const $config = (key, def) => {
    return _.get(pageConfig || {}, key, def);
};

export let $context;

const isEducation = () => {
  const { init_categories } = pageConfig;
  let categories = init_categories ? init_categories.split(';') : [];
  return pageConfig.plan === BASE_PLAN_SUB_TYPES.EDUCATION || categories.includes(BASE_PLAN_SUB_TYPES.EDUCATION);
}


export default {
    install(Vue) {
        Vue.prototype.$t = translation;

        Vue.prototype.$tracking = $tracking;

        Vue.prototype.$query = window.$query = $query;

        Vue.prototype.$cookie = window.$cookie = $cookie;

        Vue.prototype.$loading = window.$loading = (is = true) => {
            if (is) {
                let text = '';
                if (typeof is === 'string') {
                    text = is;
                }
                loader && loader.close();
                loader = Loading.service({
                    lock: true,
                    text,
                    customClass: 'opc-global-loading',
                })
            } else if (is === false) {
                loader.close();
            }
        };

        Vue.prototype.$config = window.$config = $config;

        Vue.prototype.$campaignFlags = window.campaignFlags;
        Vue.prototype.$isEnabled = window.$isEnabled = function(feature) {
            // window.campaignFlags[feature]: Unsupported ｜ true ｜ false
            return window.campaignFlags[feature] === true;
        }

        Vue.prototype.$money = window.$money = transferMoney;
        Vue.prototype.$priceByMonth = window.$priceByMonth = priceByMonth;
        $context = {
            flow: pageConfig.type, // flow type
            type: pageConfig?.editConfig?.planType, // current config plan type
            pageType: pageConfig.pageType ?? PageTypes.normal,
            currency: getCurrency(),
            $on: globalEventBus.$on.bind(globalEventBus),
            $off: globalEventBus.$off.bind(globalEventBus),
            $emit: globalEventBus.$emit.bind(globalEventBus),
            is: {
                // responsive mobile/tablet/desktop
                mobile: isBasic2ProInClient() ? isMobileInClient : isMobile,
                tablet: isBasic2ProInClient() ? isTabletInClient : isTablet,
                desktop: isBasic2ProInClient() ? isDesktopInClient : isDesktop,
                modal: pageConfig.pageType === PageTypes.modal,
                // session
                loggedIn: window.SB?.loggedIn ?? false,
                // page mode
                embedded: false, // launched in iframe or modal
                // flow
                buyNow: pageConfig.type === flowTypes.buyNow,
                // FREE TRIAL
                add2trial: pageConfig.type === flowTypes.add2trial,
                // BUY TRIAL
                buyTrial: pageConfig.type === flowTypes.buyTrial,
                add2cart: pageConfig.type === flowTypes.add2cart,
                basic2pro: pageConfig.type === flowTypes.basic2pro,
                pro2biz: pageConfig.type === flowTypes.pro2biz,
                edit: pageConfig.type === flowTypes.edit,
                edu: isEducation(),
                // edit flow of delta view
                delta: pageConfig.preloadCartInfo?.configData?.type === SHARE_TYPE_ENUM.ADD_QTY && pageConfig.type === flowTypes.edit,
                modalDelta: pageConfig.pageType === PageTypes.modal && pageConfig?.addQty > 0,
                upgrade: pageConfig.type === flowTypes.upgrade,
                downgrade: pageConfig.type === flowTypes.downgrade,
                trial2paid: pageConfig.type === flowTypes.trial2paid,
                mixBuy: pageConfig.type === flowTypes.mixBuy,
                pro2bundle: pageConfig.type === flowTypes.pro2bundle,
                biz2bundle: pageConfig.type === flowTypes.biz2bundle,
                prop2bundle: pageConfig.type === flowTypes.prop2bundle,
                pro2prop: pageConfig.type === flowTypes.pro2prop,
                zs2ze: pageConfig.type === flowTypes.zs2ze,
                esc2escp: pageConfig.type === flowTypes.esc2escp,
                edu2esc: pageConfig.type === flowTypes.edu2esc,
                switch: pageConfig.type === flowTypes.switch,
                billingBasicPlusOffer: /^billingBasicPlusOffer$/i.test(pageConfig.ref),
                billingGetOffer: /^billingGetOffer$/i.test(pageConfig.ref),
                pbx2prop: pageConfig.type === flowTypes.pbx2prop,
                winback: /^winback$/i.test(pageConfig.ref),
                isFreeWinback: /^winback$/i.test(pageConfig.ref) && pageConfig.type === flowTypes.basic2pro,
                biz2pro: pageConfig.type === flowTypes.biz2pro,
                /* functions will be rewritten as getter, see ref0 */
                // account
                withCC: () => Vue.__rootApp__?.$store.getters.withCcAccount,
                bulkLicense: () => Vue.__rootApp__?.$store.getters.basicConfig?.isBulkLicenseAccount,
                // router
                configPage: () => Vue.__rootApp__?.$router?.currentRoute?.path === routePathMap.config,
                checkoutPage: () => Vue.__rootApp__?.$router?.currentRoute?.path === routePathMap.checkout,
                editPage: () => Vue.__rootApp__?.$router?.currentRoute?.path === routePathMap.edit,
                addPage: () => Vue.__rootApp__?.$router?.currentRoute?.path === routePathMap.add,
                fromCampaignLink: () => isEmptyVal(pageConfig?.marketingCoupon) === false,
                fromPersistentCart: pageConfig?.persist_cart === "true",
            },
        };

        Object.keys($context.is).forEach(key => {
            // ref0
            if (typeof $context.is[key] === 'function') {
                Object.defineProperty($context.is, key, { get: $context.is[key] });
            }
        });

        Vue.prototype.$context = window.$context = $context;
    }
};
